import createIcon from '../../createIcon';

/**
 * @component @name TempleBuddhist
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgOS41MkMyMSAxMC42MSAyMC4xMSAxMS41IDE5LjAyIDExLjVINC45OEMzLjg5IDExLjUgMyAxMC42MSAzIDkuNTJIMUMxIDExLjM4IDIuMjggMTIuOTIgNCAxMy4zNlYyMi41SDEwVjE5LjVDMTAgMTguNCAxMC45IDE3LjUgMTIgMTcuNUMxMy4xIDE3LjUgMTQgMTguNCAxNCAxOS41VjIyLjVIMjBWMTMuMzZDMjAuNTUgMTMuMjIgMjMgMTIuMzIgMjMgOS41TDIxIDkuNTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNiA5LjM2VjEwLjVIMThWOS4zNkMxOC41NSA5LjIyIDIxIDguMzIgMjEgNS41TDE5IDUuNTJDMTkgNi42MSAxOC4xMSA3LjUgMTcuMDIgNy41SDYuOThDNS44OSA3LjUgNSA2LjYxIDUgNS41MkgzQzMgNy4zNyA0LjI4IDguOTIgNiA5LjM2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDEuNUw4LjI1IDYuNUgxNS43NUwxMiAxLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TempleBuddhist = createIcon('TempleBuddhist', [
  [
    'path',
    {
      d: 'M21 9.52C21 10.61 20.11 11.5 19.02 11.5H4.98C3.89 11.5 3 10.61 3 9.52H1C1 11.38 2.28 12.92 4 13.36V22.5H10V19.5C10 18.4 10.9 17.5 12 17.5C13.1 17.5 14 18.4 14 19.5V22.5H20V13.36C20.55 13.22 23 12.32 23 9.5L21 9.52Z',
      key: '18dv26',
    },
  ],
  [
    'path',
    {
      d: 'M6 9.36V10.5H18V9.36C18.55 9.22 21 8.32 21 5.5L19 5.52C19 6.61 18.11 7.5 17.02 7.5H6.98C5.89 7.5 5 6.61 5 5.52H3C3 7.37 4.28 8.92 6 9.36Z',
      key: 'dpi971',
    },
  ],
  ['path', { d: 'M12 1.5L8.25 6.5H15.75L12 1.5Z', key: '4cvmtr' }],
]);

export default TempleBuddhist;
